import React, { useState } from "react";
import {
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

import { useStore } from "@store/store";
import Loader from "@components/loader";
import { ListCustomerPopupStyle } from "./style";

function ListCustomerPopup(props) {
  const classes = ListCustomerPopupStyle();
  const [state] = useStore();
  const [scroll] = useState("body");

  return (
    <>
      <Dialog
        open={props.open}
        className={classes.customModal}
        scroll={scroll}
        onClose={props.handleClose}
      >
        <Loader
          loading={state?.connectedUser?.customersInConnectedUserLoading}
        />
        {state?.connectedUser?.customersInConnectedUserLoading ? (
          <TableContainer component={Paper} className={classes.customTable}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className="name">Name</TableCell>
                  <TableCell className="city">City</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className="name"><Skeleton variant="rounded" height={25} /></TableCell>
                  <TableCell className="city"><Skeleton variant="rounded" height={25} /></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TableContainer component={Paper} className={classes.customTable}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className="name">Name</TableCell>
                  <TableCell className="city">City</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.customerData.length === 0 ? (
                  <TableRow>
                    <TableCell>No Data Found</TableCell>
                  </TableRow>
                ) : (
                  props.customerData.map((item, index) => (
                    <TableRow key={item.id ?? index}>
                      <TableCell className="name">{item.name}</TableCell>
                      <TableCell className="city">{item.cities.name}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Dialog>
    </>
  );
}
export default ListCustomerPopup;
